module.exports = __webpack_public_path__ + "static/media/SuccessInvite.c14922a5.svg";